var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2",attrs:{"x-small":"","text":"","outlined":""},on:{"click":function($event){return _vm.copyToClipboard(_vm.value)}}},[_c('v-icon',{attrs:{"x-small":""}},[_vm._v("mdi-content-copy")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }